import React from "react";
import Icon from "./Icon";


export default function Modal(props) {
  return (
    <div className="ds-modal">
      <div>
        <h2 className="t-heading-m">{props.title}</h2>

        <button onClick={props.onclose}>
          <Icon icon="misc-cancel" />
        </button>
      </div>

      <div className="content">{props.children}</div>
    </div>
  )
}


/*

Usage:

<Overlay>
  <Modal title=""></Modal>
</Overlay>

- title: String

*/